module.exports = __webpack_public_path__ + "static/media/ams-adhoc-btn.827d4d4a.svg";